import { getJson } from './BaseApi.js'

export const getRoutingConfig = function () {
  return getJson({ url: '/api/config/routing' })
}
